import { connectSsr } from '@bart.sk-eshop/ssr-service';
import { connect } from 'react-redux';
import * as React from 'react';
import { Container } from '../../theme/libraries/grid';
import { prop, getBaseUrl } from '../../utilities';
import styled from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router';
import {
  ButtonStyledStyles,
  ButtonStyles,
} from '../../components/_helpers/form/Button';
import { __ } from '@bart.sk-eshop/react-i18n';

interface Props {
  text: any;
  urlMapData: any;
}

const Content = styled.div`
  margin: ${rem(40)} ${rem(10)} ${rem(40)} ${rem(10)};
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${rem(30)};
`;

const Button = styled(Link)`
  ${ButtonStyles};
  ${ButtonStyledStyles};
  min-width: ${rem(200)};
`;

class NotFound extends React.Component<Props> {
  public static async getInitialProps(props) {
    return props;
  }

  public text = () => {
    return {
      __html:
        this.props.text &&
        this.props.text.content &&
        this.props.text.content.json_content.body,
    };
  };

  public componentDidMount() {
    const urlMapData = this.props.urlMapData;
    if (urlMapData && urlMapData.type === 'redirect') {
      if (urlMapData.data && urlMapData.data.new_url && window) {
        window.location.replace(getBaseUrl(urlMapData.data.new_url));
      }
    }
  }

  public render() {
    return (
      <Container className="base">
        <Content>
          <div dangerouslySetInnerHTML={this.text()} />
          <ButtonWrapper>
            <Button to="/" className="primary lg">
              {' '}
              {__('Prejsť do e-shopu')}{' '}
            </Button>
          </ButtonWrapper>
        </Content>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    text: prop(state.general.otherTexts, 'PAGE_NOT_FOUND'),
  };
};

export default connect(mapStateToProps)(
  connectSsr({ displayName: 'NotFound' })(NotFound),
);
